import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { ClientError } from "graphql-request";

import { graphql } from "lib/generated/app-service-gql";
import {
  DocumentFindLeadsStartMutation,
  DocumentFindLeadsStartMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";
import { writeFindLeadsRunning } from "./useDocumentFindLeadsCached";

const documentFindLeadsStartMutation = graphql(`
  mutation documentFindLeadsStart($documentId: String!) {
    documentFindLeadsStart(documentId: $documentId) {
      operationId
      status
    }
  }
`);

export function useDocumentFindLeadsStart(
  options?: UseMutationOptions<
    DocumentFindLeadsStartMutation,
    ClientError,
    DocumentFindLeadsStartMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();

  return useGraphQlMutation(documentFindLeadsStartMutation, {
    ...options,
    onSuccess: (data, variables, context) => {
      writeFindLeadsRunning(
        queryClient,
        variables.documentId,
        data.documentFindLeadsStart.operationId,
      );
      options?.onSuccess?.(data, variables, context);
    },
  });
}
